//admin/PianosAdmin.js
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSignInAlt, FaSignOutAlt, FaImage, FaSave } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './PianosAdmin.css';
import { NumericFormat } from 'react-number-format';

const PianosAdmin = () => {
  const [pianos, setPianos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [editingId, setEditingId] = useState(null);
const [formData, setFormData] = useState({
  marca: '',
  modelo: '',
  valor: '',
  descricao: '',
  foto_principal: '',
  status: 'disponivel',
  galeria: [] // Já está inicializado como array, mas vamos garantir no handleEdit
});




  const [newImage, setNewImage] = useState('');
  const [newGalleryImage, setNewGalleryImage] = useState('');
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });

  // Adicione esses novos estados
const [uploading, setUploading] = useState(false);
const [uploadProgress, setUploadProgress] = useState(0);

// Função para upload de imagens
const handleImageUpload = async (file, isGallery = false) => {
  if (!file) return;
  
  const formData = new FormData();
  formData.append('image', file);
  
  try {
    setUploading(true);
    setUploadProgress(0);
    
    const response = await fetch('https://pianoswaldir.com.br/api/upload.php', {
      method: 'POST',
      credentials: 'include',
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success && data.filePath) {
      if (isGallery) {
        setFormData(prev => ({
          ...prev,
          galeria: [...(prev.galeria || []), data.filePath]
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          foto_principal: data.filePath
        }));
      }
      return data.filePath;
    }
  } catch (error) {
    console.error('Erro no upload:', error);
    alert('Erro ao fazer upload da imagem');
    return null;
  } finally {
    setUploading(false);
    setUploadProgress(0);
  }
};

  useEffect(() => {
    const checkAuth = () => {
      const isLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
      setLoggedIn(isLoggedIn);
      if (isLoggedIn) {
        fetchPianos();
      }
    };

    checkAuth();
  }, []);

const fetchPianos = async () => {
  try {
    const response = await fetch('https://pianoswaldir.com.br/api/pianos.php?action=admin_list', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.text();
    try {
      const data = JSON.parse(text);
      setPianos(data);
      setLoading(false);
    } catch (e) {
      console.error('Resposta não é JSON válido:', text);
      throw new Error('Resposta inválida do servidor');
    }
  } catch (error) {
    console.error('Erro completo ao carregar pianos:', error);
    if (error.message.includes('401')) {
      localStorage.removeItem('adminLoggedIn');
      setLoggedIn(false);
    }
    setLoading(false);
  }
};

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://pianoswaldir.com.br/api/pianos.php?action=login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });
      
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('adminLoggedIn', 'true');
        setLoggedIn(true);
        fetchPianos();
      } else {
        alert('Credenciais inválidas');
      }
    } catch (error) {
      console.error('Erro no login:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await fetch('https://pianoswaldir.com.br/api/pianos.php?action=logout', {
        method: 'POST'
      });
      localStorage.removeItem('adminLoggedIn');
      setLoggedIn(false);
    } catch (error) {
      console.error('Erro no logout:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

// No handleEdit, garanta que galeria seja um array
const handleEdit = (piano) => {
  setEditingId(piano.id);
  setFormData({
    marca: piano.marca,
    modelo: piano.modelo,
    valor: piano.valor,
    descricao: piano.descricao,
    foto_principal: piano.foto_principal,
    status: piano.status,
    galeria: Array.isArray(piano.galeria) ? piano.galeria.map(img => img.foto) : []
  });
};

  const handleCancelEdit = () => {
    setEditingId(null);
    setFormData({
      marca: '',
      modelo: '',
      valor: '',
      descricao: '',
      foto_principal: '',
      status: 'disponivel',
      galeria: []
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const url = editingId ? 
      `https://pianoswaldir.com.br/api/pianos.php?action=edit` : 
      `https://pianoswaldir.com.br/api/pianos.php?action=add`;
    
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include', // Isso é essencial para enviar cookies
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('adminLoggedIn')}`
      },
      body: JSON.stringify(editingId ? { ...formData, id: editingId } : formData)
    });

    // Verifique se a sessão expirou
    if (response.status === 401) {
      localStorage.removeItem('adminLoggedIn');
      setLoggedIn(false);
      alert('Sessão expirada. Faça login novamente.');
      return;
    }
    
    const data = await response.json();
    if (data.success) {
      fetchPianos();
      handleCancelEdit();
    } else {
      alert(data.error || 'Erro ao salvar piano');
    }
  } catch (error) {
    console.error('Erro ao salvar piano:', error);
    alert('Erro na comunicação com o servidor');
  }
};

const handleDelete = async (id) => {
  if (window.confirm('Tem certeza que deseja excluir este piano?')) {
    try {
      const response = await fetch(`https://pianoswaldir.com.br/api/pianos.php?action=delete&id=${id}`, {
        method: 'DELETE',
        credentials: 'include', // Adicione esta linha
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('adminLoggedIn')}`
        }
      });

      // Verifique se a sessão expirou
      if (response.status === 401) {
        localStorage.removeItem('adminLoggedIn');
        setLoggedIn(false);
        alert('Sessão expirada. Faça login novamente.');
        return;
      }

      const data = await response.json();
      if (data.success) {
        fetchPianos();
      } else {
        alert(data.error || 'Erro ao excluir piano');
      }
    } catch (error) {
      console.error('Erro ao excluir piano:', error);
      alert('Erro na comunicação com o servidor');
    }
  }
};

  const addGalleryImage = () => {
    if (newGalleryImage.trim()) {
      setFormData({
        ...formData,
        galeria: [...formData.galeria, newGalleryImage]
      });
      setNewGalleryImage('');
    }
  };

  const removeGalleryImage = (index) => {
    const newGallery = [...formData.galeria];
    newGallery.splice(index, 1);
    setFormData({
      ...formData,
      galeria: newGallery
    });
  };

  // ... (imports permanecem os mesmos)



  if (!loggedIn) {
    return (
      <div className="admin-login">
        <h2>Login Administrativo</h2>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Usuário"
            value={credentials.username}
            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
          />
          <input
            type="password"
            placeholder="Senha"
            value={credentials.password}
            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
          />
          <button type="submit">Entrar</button>
        </form>
      </div>
    );
  }



 
      return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>Painel Administrativo - Pianos</h1>
        <button onClick={handleLogout} className="logout-button">
          <FaSignOutAlt /> Sair
        </button>
      </div>

      <div className="admin-content">
        <motion.div
          className="piano-form"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h2>{editingId ? 'Editar Piano' : 'Adicionar Novo Piano'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Marca</label>
                <input
                  type="text"
                  name="marca"
                  value={formData.marca}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Modelo</label>
                <input
                  type="text"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
<div className="form-group">
  <label>Valor (R$)</label>
  <NumericFormat
    thousandSeparator="."
    decimalSeparator=","
    prefix="R$ "
    name="valor"
    value={formData.valor}
    onValueChange={(values) => {
      setFormData({
        ...formData,
        valor: values.value // valor puro, sem máscara, para salvar no banco
      });
    }}
    className="input"
    required
  />
</div>
              <div className="form-group">
                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  required
                >
                  <option value="disponivel">Disponível</option>
                  <option value="vendido">Vendido</option>
                  <option value="em_breve">Em Breve</option>
                </select>
              </div>
            </div>

<div className="form-group">
  <label>Foto Principal</label>
  <div className="image-input">
    <input
      type="file"
      accept="image/*"
      onChange={(e) => {
        if (e.target.files && e.target.files[0]) {
          handleImageUpload(e.target.files[0]);
          e.target.value = ''; // Reset input para permitir novo upload do mesmo arquivo
        }
      }}
      disabled={uploading}
    />
    {uploading && (
      <div className="upload-progress">
        <progress value={uploadProgress} max="100" />
        <span>{uploadProgress}%</span>
      </div>
    )}
    {formData.foto_principal && (
      <img 
        src={formData.foto_principal} 
        alt="Preview" 
        className="image-preview"
      />
    )}
  </div>
</div>

<div className="form-group">
  <label>Galeria de Fotos</label>
  <div className="gallery-input">
    <input
      type="file"
      accept="image/*"
      onChange={(e) => {
        if (e.target.files && e.target.files[0]) {
          handleImageUpload(e.target.files[0], true);
          e.target.value = ''; // Reset input
        }
      }}
      disabled={uploading}
    />
    {uploading && (
      <div className="upload-progress">
        <progress value={uploadProgress} max="100" />
        <span>{uploadProgress}%</span>
      </div>
    )}
  </div>
  
  <div className="gallery-preview">
    {(formData.galeria || []).map((img, index) => (
      <div key={index} className="gallery-item">
        <img src={img} alt={`Preview ${index}`} />
        <button 
          type="button"
          onClick={() => removeGalleryImage(index)}
          className="remove-image-button"
        >
          <FaTrash />
        </button>
      </div>
    ))}
  </div>
</div>

            <div className="form-group">
              <label>Descrição</label>
              <textarea
                name="descricao"
                value={formData.descricao}
                onChange={handleInputChange}
                rows="5"
                required
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="save-button">
                <FaSave /> {editingId ? 'Atualizar' : 'Salvar'}
              </button>
              {editingId && (
                <button 
                  type="button" 
                  onClick={handleCancelEdit}
                  className="cancel-button"
                >
                  Cancelar
                </button>
              )}
            </div>
          </form>
        </motion.div>

        <div className="pianos-list">
          <h2>Pianos Cadastrados</h2>
          {loading ? (
            <div className="loading">Carregando...</div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Marca/Modelo</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pianos.map((piano) => (
                    <motion.tr
                      key={piano.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.3 }}
                    >
                      <td>
                        <div className="piano-info">
                          <img 
                            src={piano.foto_principal} 
                            alt={piano.marca} 
                            className="piano-thumb"
                          />
                          <span>{piano.marca} {piano.modelo}</span>
                        </div>
                      </td>
                      <td>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        }).format(piano.valor)}
                      </td>
                      <td>
                        <span className={`status-badge ${piano.status}`}>
                          {piano.status === 'disponivel' ? 'Disponível' : 
                           piano.status === 'vendido' ? 'Vendido' : 'Em Breve'}
                        </span>
                      </td>
                      <td>
                        <div className="actions">
                          <button 
                            onClick={() => handleEdit(piano)}
                            className="edit-button"
                          >
                            <FaEdit />
                          </button>
                          <button 
                            onClick={() => handleDelete(piano.id)}
                            className="delete-button"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 

export default PianosAdmin;